import { MediaFragment } from '@graphql/generated/graphql';
import { getStrapiAssetUrl } from '@lib/strapi';

export const parseVideo = (media: MediaFragment) => {
    const hdMp4Src = getStrapiAssetUrl(media.formats?.['hd_mp4']);
    const fallbackSrc = `${process.env.NEXT_PUBLIC_AWS_CF_URL}/${media.hash}${media.ext}`;

    return {
        poster: getStrapiAssetUrl(media.formats?.thumbnail),
        sources: [
            { src: hdMp4Src, type: 'video/mp4' as const },
            { src: fallbackSrc, type: 'video/mp4' as const },
        ].filter(
            (s): s is { src: string; type: 'video/mp4' } => s.src !== undefined
        ),
    };
};
